import React, { useContext, useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import LeadDetailsSupply from "components/sales/formSection/leadDetails/leadDetailsSupply";
import PocDetails from "components/sales/formSection/pocDetails/pocDetails";
import Location from "components/sales/formSection/location/location";
import Layout from "components/sales/layout/layout";
import CategoryDetails from "components/sales/formSection/categoryDetails/categoryDetails";
import { Button } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import BulkUpload from "components/sales/bulkUpload/bulkUpload";

const Supply = ({
  locationCity,
  cities,
  locationZone,
  zones,
  locationArea,
  areas,
  locationType,
  locTypesData,
  locationState,
  state,
  createSupplyLead,
  locationPinCode,
  pincodeData,
  pocSubSiteTypeData,
  pocSubSiteType,
  supDropDownData,
  getSupplyDropDown,
  getCurrentLocation,
  latlng,
  toastMsg,
  BulkUploadLead,
  getSampleFileLead,
  sampleData,
  documentUploadUrl,
  documentUrlData,
}) => {
  const corporateInput = {
    leadDetails: null,
    pocDetails: null,
    location: null,
    categoryDetails: null,
  };
  const { baseUrl } = useContext(BaseUrl);
  const [corporateData, setCorporateData] = useState(corporateInput);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isbulk, setIsbulk] = useState(false);
  const [isUploaded, setIsuploaded] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDefalut, setIsDefalut] = useState(false);

  const handleLeadSubmit = (val) => {
    setCorporateData({ ...corporateData, leadDetails: val });
    setIsDefalut(false);
  };
  const handlePocSubmit = (val) => {
    setCorporateData({ ...corporateData, pocDetails: val });
    setIsDefalut(false);
  };
  const handleLocSubmit = (val) => {
    setCorporateData({ ...corporateData, location: val });
    setIsDefalut(false);
  };
  const handleCatSubmit = (val) => {
    // console.log(val);
    setCorporateData({ ...corporateData, categoryDetails: val });
    setIsDefalut(false);
  };
  const handleModalHide = () => {
    setCorporateData(corporateInput);
    setIsDefalut(true);
    setIsModal(false);
  };
  const handleSubmit = () => {
    const {
      leadDetails,
      pocDetails,
      location,
      categoryDetails,
    } = corporateData;
    /* if (categoryDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false); */
    if (
      leadDetails === null ||
      pocDetails === null ||
      location === null ||
      categoryDetails === null
    ) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);    
      (async () => {
        setIsLoading(true);
        const res = await createSupplyLead({
          ...leadDetails,
          ...pocDetails,
          ...location,
          ...categoryDetails,
        });
        setIsLoading(false);
        localStorage.removeItem("currentLocation");
        if (res) {
          setIsModal(true);
        }
      })();
    }
  };

  useEffect(() => {
    (async () => {
      await getSampleFileLead();
    })();
  }, [getSampleFileLead]);

  const headerBtns = () => {
    return (
      <Fragment>
        {/* <Button onClick={() => setIsbulk(true)} className="btn btn-transparent">
          {localization.bulkUpload}
        </Button> */}
      </Fragment>
    );
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSupplyDropDown();
      setIsLoading(false);
    })();
  }, [getSupplyDropDown]);

  const handlebulkSubmit = async () => {
    if (bulkFile !== null) {
      const res = await BulkUploadLead(bulkFile);
      if (res) {
        setIsuploaded(true);
      } else {
        setIsuploaded(false);
      }
    }
  };
  const handleFileChange = (val) => setBulkFile(val);

  return (
    <Layout
      title={localization.createLeadSupply}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isLoading={isLoading}
    >
      <LeadDetailsSupply
        inputLabel={localization.clientName}
        isSupply={true}
        handleValue={handleLeadSubmit}
        pocSubSiteTypeData={pocSubSiteTypeData}
        pocSubSiteType={pocSubSiteType}
        supDropDownData={supDropDownData}
        isDefalut={isDefalut}
        documentUploadUrl={documentUploadUrl}
      />
      <PocDetails
        isSupply={true}
        handleValue={handlePocSubmit}
        isDefalut={isDefalut}
      />
      <Location
        isSupply={true}
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        state={state}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        isDefalut={isDefalut}
      />
      <CategoryDetails
        isSupply={true}
        supDropDownData={supDropDownData}
        handleValue={handleCatSubmit}
        isDefalut={isDefalut}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      <Fragment>
        <div className="btn-group">
          <Button
            onClick={handleSubmit}
            className="d-none d-md-inline-block 
         d-md-none d-block xs-fullwidth btncrp"
          >
            {localization.submitDtl}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </Fragment>

      <BulkUpload
        sampleData={sampleData && sampleData}
        handleModalHide={() => setIsbulk(!isbulk)}
        handlebulkSubmit={handlebulkSubmit}
        isbulk={isbulk}
        handleFileChange={handleFileChange}
        isUploaded={isUploaded}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          <Button
            onClick={() => {
              handleModalHide();
              getSupplyDropDown();
            }}
            className="btn btn-primary"
          >
            {localization.createAnother}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

Supply.propTypes = {
  locationCity: PropTypes.func,
  cities: PropTypes.any,
  locationZone: PropTypes.func,
  zones: PropTypes.any,
  locationArea: PropTypes.func,
  areas: PropTypes.any,
  locationType: PropTypes.func,
  locTypesData: PropTypes.any,
  locationState: PropTypes.func,
  state: PropTypes.any,
  locationPinCode: PropTypes.func,
  pincodeData: PropTypes.any,
  createAllianceLead: PropTypes.func,
  getB2bDropDown: PropTypes.func,
  b2bDropDown: PropTypes.any,
  getCurrentLocation: PropTypes.any,
  latlng: PropTypes.any,
  toastMsg: PropTypes.any,
  BulkUploadLead: PropTypes.func,
};

export default Supply;
